
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-center",
      function () {
        return require("private-next-pages/help-center/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-center"])
      });
    }
  